import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import TextField from '@mui/material/TextField';
// import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import { getTrainingApisToken } from '../../api/apiRequests/user';
import { RootState } from '@/redux/store';

const TrainingApisToken: FC = () => {
	const { t } = useTranslation();
	const [isCopied, setIsCopied] = useState(false);
	const [tokenValue, setTokenValue] = useState<string | null>(null);
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);

	// const { data: currentUser } = useUserMeQuery();
	const { data: trainingToken } = useQuery<{ token: string }, Error>(
		['trainingToken'],
		() => getTrainingApisToken(),
	);

	useEffect(() => {
		setIsCopied(false);
	}, []);

	useEffect(() => {
		if (trainingToken) {
			setTokenValue(trainingToken.token);
		}
	}, [trainingToken]);

	const copyLink = () => {
		setIsCopied(true);
		setTimeout(() => {
			if (tokenValue) {
				navigator.clipboard.writeText(tokenValue);
			}
			setIsCopied(() => false);
		}, 1000);
	};

	return tokenValue ? (
		<div>
			<Typography
				component="div"
				variant="body1"
				sx={{ fontWeight: 600, paddingBottom: '10px', mt: 2 }}
			>
				Token for training APIs
			</Typography>
			<div style={{ display: 'flex' }}>
				<TextField
					sx={{
						width: '300px',
						marginRight: '10px',
						'& input.disabled': {
							color: isDarkTheme ? '#fff' : 'inherit',
						},
					}}
					id="standard-basic"
					variant="standard"
					disabled
					value={tokenValue}
				/>
				{!isCopied ? (
					<Tooltip title={t('copy')} placement="top">
						<ContentCopyIcon
							color="primary"
							style={{ cursor: 'pointer' }}
							onClick={copyLink}
						/>
					</Tooltip>
				) : (
					<Tooltip title={`${t('copied')}!`} placement="top">
						<LibraryAddCheckIcon color="success" style={{ cursor: 'pointer' }} />
					</Tooltip>
				)}
			</div>
		</div>
	) : null;
};

export default TrainingApisToken;
